import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { DataGrid } from "@material-ui/data-grid";
import useFetchAutoDGReportData from '../../Hooks/AutoDG/useFetchAutoDGReport';
import AutoDGPlateReport from './AutoDGPlateReport';
import Spinner from '../../common/Spinner';
import { Link } from 'react-router-dom';

const AutoDGReport = () => {

    const { plate_uuid } = useParams();
    const [searchQuery, setSearchQuery] = useState("");
    const [rows, setRows] = useState([]);
    const { data, isSuccess, isFetching, isError, error } = useFetchAutoDGReportData(plate_uuid);
    useEffect(() => {
        const well_data = data?.data?.Well_Data?.data[0];
        // Define the function to update the rows based on searchQuery
        const updateRows = (data) => {
            if (searchQuery?.length >= 3) {
                const filteredData = data?.filter((row) =>
                    row?.well_id.includes(searchQuery)
                    //  row?.well_id?.toLowerCase().includes(searchQuery?.toLowerCase())
                );
                setRows(filteredData);
            } else {
                setRows(data); // Reset to original data if query is too short
            }
        }

        if (well_data) {
            const initialRowsData = well_data?.map(item => ({
                "accepted_events": item["Accepted Events"],
                "failures": item.Failures,
                "polydispersity%": item["Polydispersity %"],
                "total_events": item["Total Events"],
                "well_id": item.Well,
                "id": crypto.randomUUID() // Generate a random ID for each row
            }));

            updateRows(initialRowsData); // Update rows based on the initial data
        }
    }, [data, searchQuery]);
    const cols = [

        {
            field: 'well_id',
            headerName: 'Well Name',
            description: 'Well Name',
            width: 350,
            renderCell: (params) => (

                <span className={`${params.row.failures !== 'None' ? 'text-red-500 font-bold' : ''}`}>
                    {params.value}
                </span>
            ),
        },
        {
            field: 'accepted_events',
            headerName: 'Accepted Event Count',
            description: 'Accepted Event Count',
            width: 320, renderCell: (params) => (

                <span className={`${params.row.failures !== 'None' ? 'text-red-500 font-bold' : ''}`}>
                    {params.value}
                </span>
            ),
        },
        {
            field: 'polydispersity%',
            headerName: 'Polydispersity %',
            description: 'Polydispersity %',
            width: 400,
            renderCell: (params) => (

                <span className={`${params.row.failures !== 'None' ? 'text-red-500 font-bold' : ''}`}>
                    {params.value}
                </span>
            ),
        },
        {
            field: 'failures',
            headerName: 'Failures',
            description: 'Failures',
            width: 200,
            renderCell: (params) => (
                <span className={`${params.row.failures !== 'None' ? 'text-red-500 font-bold' : ''}`}>
                    {params.value}
                </span>
            ),
        },

    ];


    return (
        <>

            <h5 className="text-custom-green font-bold text-center pb-10">Auto DG Report</h5>
            <div className="flex flex-grow min-h-screen">
                <div className="flex flex-col  w-full">
                    <div className="flex min-h-[25vh] pt-10 pl-10 pr-10 w-full">
                        <div className='flex-1'>
                            <AutoDGPlateReport />
                        </div>
                    </div>

                    <div className='pl-10 pt-20 pb-5'>
                        <input
                            type="text"
                            value={searchQuery}
                            placeholder="Search Well #..."
                            className="border border-gray rounded-[8px] px-2 py-1 text-sm w-40 focus:outline-none focus:ring-2 focus:ring-custom-green"
                            onChange={(event) => setSearchQuery(event.target.value)}
                        />
                    </div>

                    <div className="flex flex-grow pl-10 pr-10 pb-10">

                        {isFetching ? <Spinner text="Fetching Data... Pls wait" /> : isSuccess ?
                            <DataGrid columns={cols} rows={rows} sx={{
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    color: 'text-custom-green',
                                },
                            }} />

                            : isError ? <p>{error}</p> : null}
                    </div>

                </div>
            </div>

            <div className='flex pl-10'>
                <Link className="items-start pb-5" to="/ddpcr/autoDG/list_plates">Back To DG Plates List</Link>
            </div>

        </>
    );


};

export default AutoDGReport;